import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';

import { useTranslation } from 'react-i18next';

import { useSelector, useDispatch, connect } from 'react-redux';

import Joyride, {
  CallBackProps, STATUS,
} from 'react-joyride';

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Media,
} from 'reactstrap';

import { size, isEqual, find, includes, } from 'lodash';

import CustomTooltip from './CustomTooltip';

import * as constants from '../../../constants/constants';

import closeImg from '../../../images/icons/close.png';

import { claimTutorialBonus, setUserScreenViewNew } from '../../../actions/member';
import { getTourStateLoad, startTour, stopTour } from '../../../actions/tour';

const JoyrideComponent = ({ run, toggle, closeJoyride, tutorialBonus, fontMode, setScreenViewNew }) => {
  const { t } = useTranslation('common');

  console.log('JoyrideComponent', run, tutorialBonus, processing);

  const dispatch = useDispatch();
  const tourState = useSelector(state => state.tour);
  const member = useSelector(state => state.member);
  const [tourRound, setTourRound] = useState([]);
  const [completeTourModal, setCompleteTourModal] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [firstTourModalOpen, setFirstTourModalOpen] = useState(false);
  useEffect(() => {
    if (run) {
      try {
        if (!localStorage.getItem('joyrideActive')) {
          localStorage.setItem('joyrideActive', 'true');
        }
      } catch (err) {
        console.log(err);
      }
      dispatch(getTourStateLoad());
    }

    if (run && !tutorialBonus && !processing) {
      setFirstTourModalOpen(true);
    }

    if (tutorialBonus && firstTourModalOpen) {
      // Close tutorial modal if tutorialBonus already received and modal is opened
      setFirstTourModalOpen(false);
    }

    if (run && tutorialBonus && !processing) {
      setProcessing(true);
    }

    if (run && processing) {
      setScreenViewNew(constants.SCREENS.GAME_GUIDE);
      dispatch(startTour());
    }

    if (!run) {
      setFirstTourModalOpen(false);
      setProcessing(false);
      try {
        localStorage.removeItem('joyrideActive');
      } catch (err) {
        return null;
      }
    }
  }, [run, processing]);

  useEffect(() => {
    try {
      if (localStorage) {
        return () => {
          localStorage.removeItem('joyrideActive');
        };
      }

      return null;
    } catch (err) {
      return null;
    }
  }, []);

  /*
  useEffect(() => {
    return () => {
      localStorage.removeItem('joyrideActive');
    };
  }, []); */

  useEffect(() => {
    if (tourState && run) {
      const pageStep = find(tourState.steps, (o, k) => { return k === 0; });

      if (size(pageStep) > 0) {
        if (pageStep.tab === constants.MENU_NAVIGATION.myInfo || pageStep.tab === constants.MENU_NAVIGATION.tournaments) {
          const pageSubStep = find(tourState.steps, (o, k) => { return k === tourState.stepIndex; });
          toggle(pageSubStep?.tab || pageStep.tab);
        } else {
          toggle(pageStep.tab);
        }
      }
    }
  }, [tourState]);

  const closeTour = () => {
    setProcessing(false);
    closeJoyride();
  };

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, action, step, index } = data;
    // console.log(data, "menu callback joyride");
    if (action && step && member && !member.tutorialBonus) {
      try {
        if (localStorage.getItem('allTours')) {
          let allTours = JSON.parse(localStorage.getItem('allTours'));
          const { completeTour } = allTours;
          const newVal = [...completeTour];
          if (!includes(newVal, step.unit)) {
            newVal.push(step.unit);

            allTours = {
              ...allTours,
              completeTour: newVal,
            };
            // console.log({ allTours });

            console.log('removeItem allTours');
            localStorage.removeItem('allTours');

            console.log('set allTours', JSON.stringify(allTours));
            localStorage.setItem('allTours', JSON.stringify(allTours));
          }
        } else {
          let allTours = {
            completeTour: [],
          };
          const newVal = allTours.completeTour;
          newVal.push(step.unit);
          allTours = {
            ...allTours,
            completeTour: newVal,
          };

          console.log('set allTours', JSON.stringify(allTours));
          localStorage.setItem('allTours', JSON.stringify(allTours));
        }
      } catch (err) {
        console.log(err);
      }
    }
    const finishedStatuses: string[] = [STATUS.FINISHED, STATUS.SKIPPED, STATUS.PAUSED];

    if (finishedStatuses.includes(status) || action === 'close' || action === 'stop') {
      try {
        if (member && !member.tutorialBonus) {
          console.log("stop tour", member.tutorialBonus);

          if (localStorage.getItem('allTours') && JSON.parse(localStorage.getItem('allTours')).completeTour) {
            const allTours = JSON.parse(localStorage.getItem('allTours')).completeTour;
            allTours.sort((a, b) => { return a - b; });
            console.log(constants.TOUR_OLD_ALL_STEPS, { allTours });
            if (isEqual(constants.TOUR_OLD_ALL_STEPS, allTours)) {
              console.log("You got 3000000 bonus. WWW");

              setCompleteTourModal(true);
              dispatch(claimTutorialBonus());

              console.log('removeItem allTours');
              localStorage.removeItem('allTours');
            } else {
              console.log('removeItem allTours');
              localStorage.removeItem('allTours');
            }
          }
        } else if (member && member.tutorialBonus) {
          if (localStorage.getItem('allTours')) {
            console.log('removeItem allTours');
            localStorage.removeItem('allTours');
          }
        }
      } catch (err) {
        console.log('claimTutorialBonus err');
        console.log(err);
      }

      closeTour();
      // closeJoyride();
    }
  };

  const toggleCompleteTourModal = () => {
    setCompleteTourModal(false);
  };

  const closeJoyrideFunc = () => {
    closeJoyride();
  };

  const continueTutorial = () => {
    setProcessing(true);
    setFirstTourModalOpen(false);
  };

  console.log('JoyrideComponent222', tourState, processing);

  return (
    <>
      {
        tourState && processing && (
          <Joyride
            {...tourState}
            tooltipComponent={CustomTooltip}
            callback={handleJoyrideCallback}
            continuous
            showProgress
            showSkipButton
            scrollToFirstStep
            spotlightClicks
            spotlightPadding={0}
            styles={{
              options: {
                zIndex: 10000,
                primaryColor: 'linear-gradient(180deg,#b4ec51,#429321)',
              },
            }}
          />
        )
      }

      <Modal container={'div > div'} isOpen={firstTourModalOpen} toggle={closeTour} size="md" className={`old-modal root-font-${fontMode}`}>
        <ModalHeader
          toggle={closeTour}
          close={
            <Media src={closeImg} className="notification-header-close" alt="X" onClick={closeTour} />
        }
        >{t('common.welcomeToZole')}</ModalHeader>
        <ModalBody>
          {t('bonusPage.gameGideBounsContent')}
        </ModalBody>
        <ModalFooter>
          <Button className="modal-footer-button mb-3" color="secondary" onClick={continueTutorial}>
            {t('common.continue')}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal container={'div > div'} isOpen={completeTourModal} toggle={toggleCompleteTourModal} size="md" className="old-modal">
        <ModalHeader
          toggle={toggleCompleteTourModal}
          className={`notification-header tutorial-result-header-${fontMode}`}
          close={
            <Media src={closeImg} className="notification-header-close" alt="X" onClick={toggleCompleteTourModal} />
        }
        >{t('common.congratulations')}</ModalHeader>
        <ModalBody>
          <div className={`d-flex align-items-center flex-column text-center tutorial-result-section-${fontMode}`}>
            {t('tutorial.earnedReward')}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className={`modal-footer-button mb-3 tutorial-result-button-${fontMode}`} color="secondary" onClick={toggleCompleteTourModal}>
            {t('common.ok')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

JoyrideComponent.propsTypes = {
  run: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  closeJoyride: PropTypes.func.isRequired,
  tutorialBonus: PropTypes.bool,
  fontMode: PropTypes.string,
};

JoyrideComponent.defaultProps = {
  run: false,
  tutorialBonus: false,
  fontMode: constants.FONT_MODE.normal,
};


const mapDispatchToProps = {
  setScreenViewNew: setUserScreenViewNew,
};

export default connect(null, mapDispatchToProps)(JoyrideComponent);